import { useEffect, useState } from "react";
import { Box, Text, Button ,TextInput, Menu,createStyles, Tooltip} from "@mantine/core";
import React from "react";
import "./style.css";
import { IoMdAdd } from "react-icons/io";
import { IoPersonAddOutline } from "react-icons/io5";
import { CiSearch } from "react-icons/ci";
import { LuArrowDownUp } from "react-icons/lu";
import { getAllBillingConsumers, getAllBillingConsumersSkypoint } from "../../../services/billinginvoice";
import { useSelector } from "react-redux";
import SkypointPreviousCustomers from "./SkypointPreviousCustomers";
import { getAllSkypointProvider } from "../../../services/skypointProvider";


const useStyles = createStyles(() => ({

  tabsinner: {
     width: "15%",
    borderRadius: "8px",
  background:"#1018280D",
  border:'1px solid #D0D5DD',
    padding: "8px 14px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    textAlign: "center",
    cursor: "pointer",
    // height:'6vh'
  },}));

const SkypointCustomers = ({ setState }) => {
  const [createconsumer, setCreateConsumer] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const { classes } = useStyles();

 const { stripeaccounts  } = useSelector(
    (state) => state.settinginvoice
  );
     const {settingInvoice} = useSelector(
        (state) => state.settinginvoice
      );
  


  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query); // Update the search query state

    // Clear the previous timeout to reset the debouncing process
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    // Set a new timeout to call the API after 500ms delay
    // The table is paged (10 a page): its first page, not 'all', which stops at 200 (OD-1694)
    const timeout = setTimeout(() => {
      getAllSkypointProvider(1, 'active' , query); // Trigger the API call
    }, 500); // 500ms delay

    setDebounceTimeout(timeout); // Store the timeout ID to clear it later
  };

  useEffect(() => {
    // Cleanup the timeout when the component unmounts
    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [debounceTimeout]);

const handlefindcustomer=async(value)=>{
  await getAllSkypointProvider(1,'active', '', value)
}


  return (
    <div className="maindashbordinvoices">
      {/* <Text style={{marginTop:'20px'}} fs={16} fw={700} color="#171717">
      All Customers
      </Text> */}
      <Box className="allInvoicesSection">
        <Text fs={16} fw={700} color="#171717">
          All Providers
        </Text>
        <div style={{ display: "flex", gap: "1rem" }}>
          {/* <Button
            onClick={() => {
              setCreateConsumer(true);
            }}
            variant="filled"
            type="submit"
            c={"#000"}
            radius={"md"}
            size="md"
            style={{background:"#1018280D",border:'1px solid #D0D5DD'}}
          >
            <IoPersonAddOutline/>
            <div style={{marginLeft:'.5rem'}} >Add Provider</div>
          </Button> */}

          {
            (
              !stripeaccounts?.StripeAccounts || (
                stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending' &&
                (
                  settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
                  settingInvoice?.settinginvoice?.paymentsOptions?.ach
                )
              )
            ) ? (
              <Tooltip
                label="Your stripe account is not registered, go to settings tab and update it."
                withArrow
                position="bottom"
              >
                <img
                  width={20}
                  height={20}
                  style={{ position: "relative", top: "13px" }}
                  src="/assets/images/error.png"
                  alt="check-icon"
                />
              </Tooltip>
            ) : null
          }
          <Button
            onClick={() => {
              setState(true);
            }}
            disabled={
              !stripeaccounts?.StripeAccounts || (
                stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending' &&
                (
                  settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
                  settingInvoice?.settinginvoice?.paymentsOptions?.ach
                )
              )
            }
            variant="filled"
            type="submit"
            c={"#000"}
            radius={"md"}
            size="md"
            color="yellow"
            style={{display:"flex",gap:'.5rem'}}
          >
            <IoMdAdd size={25} />
            <div  style={{marginLeft:'.5rem'}} >New Invoice</div>
          </Button>
        </div>
      </Box>
      <Box className="dashbordinvoices">
        <div style={{display:'flex',gap:'1rem'}} >
          <TextInput
            rightSection={<CiSearch size={20} color="#737373" />}
            className="search-section"
            // left={<CiSearch />}
            placeholder="Search provider name, Date"
            value={searchQuery}
            onChange={handleSearch}
          />
          {/* <Button
            variant="filled"
            type="submit"
            c={"#000"}
            radius={"md"}
            size="md"
            style={{background:"#1018280D",border:'1px solid #D0D5DD'}}
          >
            <LuArrowDownUp />
            <div style={{marginLeft:'.5rem'}} >Sort By</div>
          </Button> */}

<Box
              // style={{ backgroundColor: settingtrue }}
              className={classes.tabsinner}
            >
              <Menu  shadow="md" width={100}>
                <Menu.Target>
                  <Box
                    style={{
                      display: "flex",
                      // gap: "20px",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                 <div>

      <LuArrowDownUp width={20} />
    </div>
                   <Text ff={14} fw={700} c={
                    '#1D2939'}  style={{marginLeft:'.5rem'}}>Sort By</Text>
                  </Box>
                </Menu.Target>

                <Menu.Dropdown pos={"bottom-start"} top={'261px'}  >
                  <Menu.Item

                  ff="Inter" fz={14} fw={600} color="#262626"
                  //  onClick={HandleNavigatepair}
                   onClick={()=>{handlefindcustomer('')}}

                  // onClick={() => handleEditProvider({ id: 1 }, true)}
                  >
                   All
            
                  </Menu.Item>
                  <Menu.Item
                            ff="Inter" fz={14} fw={600} color="#262626"
                             onClick={()=>{handlefindcustomer('active')}}

                  // onClick={() => handleEditProvider({ id: 1 }, false)}
                  >
                 Active
                
                  </Menu.Item>
                  <Menu.Item
                  ff="Inter" fz={14} fw={600} color="#262626"
                   onClick={()=>{handlefindcustomer('inactive')}}
                  >
                    InActive
                
                  </Menu.Item>
     

                  
                </Menu.Dropdown>
              </Menu>
            </Box>

        </div>
        <SkypointPreviousCustomers
          createconsumer={createconsumer}
          setCreateConsumer={setCreateConsumer}
        />
      </Box>
    </div>
  );
};

export default SkypointCustomers;
